<script setup>

import CompareCompetitorSelector from "@/components/competition/partials/compare/CompareCompetitorSelector.vue";
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import {computed} from "vue";
import {useStore} from "vuex";
import useDates from "@/composables/useDates";

const dates = useDates();

const store = useStore();
const websiteCompareData = computed(() => store.getters['competitionV2/websiteCompareData']);

</script>

<template>
  <TableHeaderRow>
    <TableHeaderCell col-span="2" />
    <TableHeaderCell col-span="2">
      <div class="tw-text-center tw-w-full">
        <span class="tw-block tw-mb-2">Your website</span>
        <span class="tw-block tw-text-grey">Audited {{ websiteCompareData?.date ? dates.formattedDate(websiteCompareData.date) : 'N/A' }}</span>
      </div>
    </TableHeaderCell>

    <TableHeaderCell col-span="2">
      <CompareCompetitorSelector column="1" />
    </TableHeaderCell>

    <TableHeaderCell col-span="2">
      <CompareCompetitorSelector column="2" />
    </TableHeaderCell>

    <TableHeaderCell col-span="2">
      <CompareCompetitorSelector column="3" />
    </TableHeaderCell>

    <TableHeaderCell col-span="2">
      <CompareCompetitorSelector column="4" />
    </TableHeaderCell>
  </TableHeaderRow>
</template>